import moment from 'moment';
import { Badge } from 'react-bootstrap';
import read from 'assets/img/read.png';
import flightIcon from 'assets/img/flights.png';
import lodgingIcon from 'assets/img/lodgings.png';
import serviceIcon from 'assets/img/other_services.png';
import packageIcon from 'assets/img/packages.png';
import React, { Component } from 'react';
import { formatTravelDate } from '../../libCustom/travelDates';

const IconImg = (props) => {
  return (
    <img
      src={props.src}
      style={{
        width: '16%',
        marginRight: '7px',
        marginTop: '5px',
      }}
      alt={props.alt || ''}
    />
  );
};

const dateFromNow = (date) => {
  return moment(date).fromNow();
};

const viewDate = (date) => {
  return moment(date).format('ll');
};

// Las fechas de viaje se guardan como día de calendario en UTC (mediodía UTC);
// se formatean con la parte de fecha UTC para que no se recorran un día según
// la zona horaria del navegador.
const travelDate = (date) => formatTravelDate(date);

// Nombre del asesor: usa generalQuotation.userId poblado y, si no viene
// (cotizaciones viejas o sin poblar), cae a assignedTo como antes.
const getAgentName = (generalQuotation, assignedTo) => {
  const agent =
    generalQuotation &&
      generalQuotation.userId &&
      generalQuotation.userId.firstName
      ? generalQuotation.userId
      : assignedTo || {};
  return (agent.firstName || '') + ' ' + (agent.lastName || '');
};

function getQuotationsLeats(document) {
  const {
    _id,
    clientId,
    dates,
    generalQuotation,
    assignedTo,
    createdAt,
    createdOn,
    updatedOn,
    updatedAt,
    flights,
    lodgings,
    otherServices,
    packages,
  } = document;

  const newDate = updatedAt !== undefined ? updatedAt : updatedOn;
  const createdDate = createdAt !== undefined ? createdAt : createdOn;

  const nameAgent = getAgentName(generalQuotation, assignedTo);

  let newDocument = {
    id: _id,
    title:
      (clientId !== undefined ? clientId.firstName : '') +
      ' ' +
      (clientId && clientId !== undefined ? clientId.lastName : ''),
    emoji: clientId ? clientId.reaction : '',
    color: '#c0392b',
    description:
      dates && dates.openDate === true
        ? 'Fecha abierta'
        : dates && dates.departureDate
          ? `${travelDate(dates.departureDate)}`
          : '',
    description2:
      generalQuotation && generalQuotation.destination
        ? generalQuotation.destination
        : '',
    description3: nameAgent,
    description4: viewDate(newDate),
    description7: createdDate,
    description5: (
      <div>
        <Badge
          style={{
            backgroundColor: '#c23823',
          }}
        >
          {dateFromNow(newDate)}
        </Badge>
      </div>
    ),
    description6: (
      <div style={{ paddingTop: '5px' }}>
        {flights && flights.length > 0 && <IconImg src={flightIcon} />}
        {lodgings && lodgings.length > 0 && <IconImg src={lodgingIcon} />}
        {otherServices && otherServices.length > 0 && (
          <IconImg src={serviceIcon} />
        )}
        {packages && packages.length > 0 && <IconImg src={packageIcon} />}
      </div>
    ),
    dateUpdate: moment(newDate).format('DD/MM/YYYY'),
    label: '30 mins',
    departureDate: dates && dates.departureDate ? dates.departureDate : null,
    openDate: dates && dates.openDate === true,
  };

  return newDocument;
}

function getQuotationsTracing(document) {
  const {
    _id,
    clientId,
    dates,
    generalQuotation,
    assignedTo,
    createdOn,
    createdAt,
    updatedAt,
    updatedOn,
    dateSended,
    flights,
    lodgings,
    otherServices,
    packages,
  } = document;

  const newDate = updatedAt !== undefined ? updatedAt : updatedOn;
  const createdDate = createdAt !== undefined ? createdAt : createdOn;

  const nameAgent = getAgentName(generalQuotation, assignedTo);

  return {
    id: _id,
    title:
      (clientId ? clientId.firstName : '') +
      ' ' +
      (clientId !== undefined && clientId.lastName ? clientId.lastName : ''),
    emoji: clientId ? clientId.reaction : '',
    color: '#7b2cbf',
    description: 'Fecha abierta',
    description2: generalQuotation.destination || '',
    description3: nameAgent,
    description4: viewDate(newDate),
    description5: (
      <div>
        <Badge
          style={{
            backgroundColor: '#8e44ad',
            color: '#ffffff',
          }}
        >
          {dateFromNow(newDate)}
        </Badge>
      </div>
    ),
    description6: (
      <div>
        {flights.length > 0 && <IconImg src={flightIcon} />}
        {lodgings.length > 0 && <IconImg src={lodgingIcon} />}
        {otherServices.length > 0 && <IconImg src={serviceIcon} />}
        {packages.length > 0 && <IconImg src={packageIcon} />}
      </div>
    ),
    description7: createdDate,
    dateUpdate: moment(newDate).format('DD/MM/YYYY'),
    label: '30 mins',
    read:
      document.read === true ? (
        <img src={read} style={{ width: '16%', marginRight: 0 }} />
      ) : null,
    departureDate: dates && dates.departureDate ? dates.departureDate : null,
    openDate: dates && dates.openDate === true,
  };
}

function getQuotationsSended(document) {
  const {
    _id,
    clientId,
    dates,
    generalQuotation,
    assignedTo,
    createdOn,
    createdAt,
    updatedAt,
    updatedOn,
    dateSended,
    flights,
    lodgings,
    otherServices,
    packages,
  } = document;

  const newDate = updatedAt !== undefined ? updatedAt : updatedOn;
  const createdDate = createdAt !== undefined ? createdAt : createdOn;

  const nameAgent = getAgentName(generalQuotation, assignedTo);

  let dateFormat = 'Sin fecha definida';
  if (dates && dates.openDate) {
    dateFormat = 'Fecha abierta';
  } else if (dates && dates.departureDate) {
    dateFormat = travelDate(dates.departureDate);
  }

  return {
    id: _id,
    title:
      (clientId ? clientId.firstName : '') +
      ' ' +
      (clientId && clientId !== undefined ? clientId.lastName : ''),
    emoji: clientId ? clientId.reaction : '',
    color: '#f1c40e',
    description: dateFormat,
    description2: generalQuotation.destination || '',
    description3: nameAgent,
    description4: viewDate(newDate),
    description5: (
      <div>
        <Badge
          style={{
            backgroundColor: '#f1c40e',
            color: '#565454',
          }}
        >
          {dateSended !== undefined
            ? 'Enviada ' + moment(dateSended).fromNow()
            : ''}
        </Badge>
      </div>
    ),
    description6: (
      <div>
        {flights.length > 0 && <IconImg src={flightIcon} />}
        {lodgings.length > 0 && <IconImg src={lodgingIcon} />}
        {otherServices.length > 0 && <IconImg src={serviceIcon} />}
        {packages.length > 0 && <IconImg src={packageIcon} />}
      </div>
    ),
    description7: createdDate,
    label: '30 mins',
    dateUpdate: moment(newDate).format('DD/MM/YYYY'),
    read:
      document.read === true ? (
        <img src={read} style={{ width: '16%', marginRight: 0 }} />
      ) : null,
    departureDate: dates && dates.departureDate ? dates.departureDate : null,
    openDate: dates && dates.openDate === true,
  };
}

function getQuotationsGuaranteed(document) {
  const {
    _id,
    clientId,
    dates,
    generalQuotation,
    assignedTo,
    flights,
    lodgings,
    otherServices,
    packages,
    createdOn,
    updatedOn,
    createdAt,
    updatedAt,
  } = document;

  const newReturnDate =
    dates.returnDate !== undefined ? dates.returnDate : dates.departureDate;
  const newUpdated = updatedAt !== undefined ? updatedAt : updatedOn;
  const createdDate = createdAt !== undefined ? createdAt : createdOn;

  const nameAgent = getAgentName(generalQuotation, assignedTo);

  var newDocument = {
    id: _id,
    title:
      (clientId ? clientId.firstName : '') +
      ' ' +
      (clientId && clientId !== undefined ? clientId.lastName : ''),
    emoji: clientId ? clientId.reaction : '',
    color: '#e67e21',
    description:
      dates.openDate === true
        ? 'Fecha abierta'
        : travelDate(dates.departureDate) || '',
    description2: generalQuotation.destination || '',
    description3: nameAgent,
    description6: (
      <div>
        {flights.length > 0 && <IconImg src={flightIcon} />}
        {lodgings.length > 0 && <IconImg src={lodgingIcon} />}
        {otherServices.length > 0 && <IconImg src={serviceIcon} />}
        {packages.length > 0 && <IconImg src={packageIcon} />}
      </div>
    ),
    description7: createdDate,
    dateDeparture: travelDate(dates.departureDate),
    dateUpdate: moment(newUpdated).format('DD/MM/YYYY'),
    label: '30 mins',
    departureDate: dates && dates.departureDate ? dates.departureDate : null,
    openDate: dates && dates.openDate === true,
  };

  return newDocument;
}

function getQuotationsAchieved(document) {
  const {
    _id,
    clientId,
    dates,
    dateSaleNote,
    generalQuotation,
    assignedTo,
    flights,
    lodgings,
    otherServices,
    packages,
  } = document;

  const nameAgent = getAgentName(generalQuotation, assignedTo);

  var newDocument = {
    id: _id,
    title:
      (clientId ? clientId.firstName : '') +
      ' ' +
      (clientId !== undefined && clientId.lastName ? clientId.lastName : ''),
    emoji: clientId ? clientId.reaction : '',
    color: '#5eb925',
    description:
      dates && dates.openDate === true
        ? 'Fecha abierta'
        : moment(dateSaleNote).format('DD/MM/YYYY') || '',
    description2:
      generalQuotation && generalQuotation.description
        ? generalQuotation.destination
        : '',
    description3: nameAgent,
    description4: (
      <div>
        {flights.length > 0 && <IconImg src={flightIcon} />}
        {lodgings.length > 0 && <IconImg src={lodgingIcon} />}
        {otherServices.length > 0 && <IconImg src={serviceIcon} />}
        {packages.length > 0 && <IconImg src={packageIcon} />}
      </div>
    ),
    label: '30 mins',
    departureDate: dates && dates.departureDate ? dates.departureDate : null,
    openDate: dates && dates.openDate === true,
  };

  return newDocument;
}

function getQuotationsDown(document) {
  const {
    _id,
    clientId,
    dates,
    generalQuotation,
    assignedTo,
    flights,
    lodgings,
    otherServices,
    packages,
  } = document;

  const nameAgent = getAgentName(generalQuotation, assignedTo);

  let newDateDeparture = dates && dates.departureDate
    ? travelDate(dates.departureDate)
    : '';

  let newDocument = {
    id: _id,
    title:
      (clientId ? clientId.firstName : '') +
      ' ' +
      (clientId !== undefined && clientId.lastName ? clientId.lastName : ''),
    emoji: clientId ? clientId.reaction : '',
    color: '#81bef7',
    description: dates && dates.openDate === true ? 'Fecha abierta' : newDateDeparture,
    description2: generalQuotation.destination || '',
    description3: nameAgent,
    description4: (
      <div>
        {flights.length > 0 && <IconImg src={flightIcon} />}
        {lodgings.length > 0 && <IconImg src={lodgingIcon} />}
        {otherServices.length > 0 && <IconImg src={serviceIcon} />}
        {packages.length > 0 && <IconImg src={packageIcon} />}
      </div>
    ),
    label: '30 mins',
    departureDate: dates && dates.departureDate ? dates.departureDate : null,
    openDate: dates && dates.openDate === true,
  };

  return newDocument;
}

export {
  getQuotationsLeats,
  getQuotationsTracing,
  getQuotationsSended,
  getQuotationsGuaranteed,
  getQuotationsAchieved,
  getQuotationsDown,
};



// WEBPACK FOOTER //
// ./src/views/Quotations/quotationsAdapter.js